import React from "react";
import "./produk.scss";
import data from "../../Component/Card/data.json";
import Card from "../../Component/Card/card";
import Cherryvilleimages from "../../Media/Produk/Cherryville";
import Gardenloftimages from "../../Media/Produk/Gardenloft";
import Kaiaimages from "../../Media/Produk/Kaia";
import Lemonadeimages from "../../Media/Produk/Lemonade";
import Levanteimages from "../../Media/Produk/Levante";
import Vicenteimages from "../../Section/Vicente/newlaunching1/Vicente10";
import Tanamasimages from "../../Media/Produk/Tanamas";
import Zlivingimages from "../../Media/Produk/Zliving";
import O8images from "../../Media/Produk/O8";
import WTimages from "../../Media/Produk/WT";
import Giva10images from "../../Media/Produk/Giva/Tipe 10/Giva10";
import Newimages from "../../Media/Altara/New";
import Citrusimages from "../../Media/Citrus/Citrus";
import Dovia9images from "../../Media/Dovia/Dovia 9/Dovia9";
import AltaraPimages from "../../Media/Altara Prime/AltaraPrime";

const imageMap = {
  Cherryvilleimages,
  Gardenloftimages,
  Kaiaimages,
  Lemonadeimages,
  Levanteimages,
  Vicenteimages,
  Tanamasimages,
  Zlivingimages,
  O8images,
  WTimages,
  Giva10images,
  Newimages,
  Citrusimages,
  Dovia9images,
  AltaraPimages,

  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="rumah" className="produk">
      <h1>Our Residentials</h1>

      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
